<template>
  <div id="sections">
      <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left :to="{ path: '/videos'}" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>            
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="!this.Project.length" class="text-center">
        <img src="static/NoPictures.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Section(s) Found !! </b></h4>
    </v-container>
    <v-container grid-list-md fluid>
          <draggable
        v-model="projectObj.section"
        class="layout wrap pb-4"
        handle=".handle"
        @start="drag=true"
        @end="drag=false"
        @change="sectionSort"
        forceFallback= "false"
      >
        <v-flex xs12 sm6 md4 lg3 pa-2 v-for="section of projectObj.section" :key="section.section.id">
            <router-link :to="{ path: `/sections/${section.section.id}`, query: { projectId: projectId }}">
          <v-card
              class="theme--light rounded-corner"
            >
              <v-card-title class="title">
                <span class="font-weight-medium text-capitalize title">{{ section.section.title }}</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="desc">
                {{ section.section.description }}
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="pa-0">
                <v-list-tile class="grow">
                  <v-list-tile-content>
                    <v-list-tile-title>No of items</v-list-tile-title>
                  </v-list-tile-content>
                <v-layout
                  align-center
                  justify-end
                  ma-auto
                >
                  <v-icon class="mr-1">insert_photo</v-icon>
                  <span class="subheading mr-2">{{ section.section.items.filter(item => item.type === 'Photo').length }}</span>
                  <span class="mr-2"></span>
                  <v-icon class="mr-1">videocam</v-icon>
                  <span class="subheading">{{ section.section.items.filter(item => item.type === 'Video').length }}</span>
                  <v-icon class="ml-3 handle">open_with</v-icon>
                </v-layout>
                </v-list-tile>
              </v-card-actions>
            </v-card>
            </router-link>
        </v-flex>
      </draggable>
    </v-container>
  </div>
</template>
<script>
/* global session store config */

import swal from 'sweetalert2';
import { getOne, getCollection, update } from '../../helpers/helpers';
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';
import $ from 'jquery';

export default {
  components: {
    draggable
  },
  data: () => ({
    entity: 'Project',
    projectId: '',
    projectObj: {},

  }),
  computed: {
    ...mapGetters(['Account']),
    Project: {
      get () {
        return store.state.Project;
      },
      set (value) {
        store.commit('setProject', value);
      }
    }
  },
  watch: {
    Project (newValue) {
      if (newValue) {
        this.projectObj = newValue.find(project => project.id === this.projectId);
      }
    }
  },
  async created () {
    this.projectId = this.$route.params.id;
    await this.projectInitialize();
    if (this.Project.length) {
      this.projectObj = await this.Project.find((project) => project.id === this.projectId);
    }
    this.projectObj.section = await this.projectObj.section.sort((a, b) => a.section.sort_no - b.section.sort_no);
    /* Set the items - item.item => item */
    this.projectObj.section = this.projectObj.section.filter(section => section.section).map(section => {
      section.section.items = section.section.items.filter(item => item.item).map(item => item.item);
      return section;
    });
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async sectionSort () {
      for (let index = 0; index < this.projectObj.section.length; index++) {
        this.projectObj.section[index].section.sort_no = index + 1;
        let { error, data, status } = await update('Section', this.projectObj.section[index].section, this.projectObj.section[index].section._id);
        if (error) {
          console.log('error', error);
        } else {
          if (this.projectObj.section.length - 1 === index) {
            swal.fire({
              type: 'success',
              title: 'sections order updated successfully',
              showConfirmButton: false,
              timer: 2500,
            });
          }
        }
      }
    },
    async projectInitialize () {
      if (!this.Project.length) {
        let populate = [{ path: 'section.section', populate: 'items.item' }];
        let where = { account: this.Account.id };
        let { error, data } = await getCollection('Project', true, 0, populate, where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Project = data;
          }
        }
      }
    },
  }
};
</script>
<style scoped>

.title {
  background: #019d8c !important;
  color: #fff;
}

.rounded-corner {
    border-radius: 5px;
}

.desc {
  min-height: 100px;
}

</style>



// WEBPACK FOOTER //
// src/pages/VideoProject/Sections.vue